import { render } from "./PlanSelectionSection.vue?vue&type=template&id=08841cca&scoped=true"
import script from "./PlanSelectionSection.vue?vue&type=script&lang=js"
export * from "./PlanSelectionSection.vue?vue&type=script&lang=js"

import "./PlanSelectionSection.vue?vue&type=style&index=0&id=08841cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08841cca"]])

export default __exports__